var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"start"},[_c('Header'),_c('Hero',{attrs:{"step":"edit"}}),_c('FahrtAuswahlEdit'),_c('BergfahrtUhrzeit'),_c('TalfahrtUhrzeit'),_c('SubsetUhrzeit'),_c('Bearbeitung_Fail'),_c('SlideNavigation',{attrs:{"prev-route":"/","next-route":"/"}}),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }